import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
let AssuranceModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('boolean'), _dec5 = attr('string'), _dec6 = attr('number'), _dec7 = attr('boolean'), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec0 = hasMany('product', {
  inverse: null,
  async: false
}), _dec1 = attr('boolean', {
  defaultValue: false
}), _class = class AssuranceModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "frase_assicurato", _descriptor2, this);
    _initializerDefineProperty(this, "frase_assicurazione", _descriptor3, this);
    _initializerDefineProperty(this, "diretta", _descriptor4, this);
    _initializerDefineProperty(this, "calcolato", _descriptor5, this);
    _initializerDefineProperty(this, "importo", _descriptor6, this);
    _initializerDefineProperty(this, "include_bollo", _descriptor7, this);
    _initializerDefineProperty(this, "include_cassa", _descriptor8, this);
    _initializerDefineProperty(this, "include_ritenuta", _descriptor9, this);
    _initializerDefineProperty(this, "products", _descriptor0, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor1, this);
  }
  get label() {
    return this.name || '';
  }
  get sub_label() {
    return this.frase_assicurato || '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "frase_assicurato", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "frase_assicurazione", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "diretta", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "calcolato", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "importo", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "include_bollo", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "include_cassa", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "include_ritenuta", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "products", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { AssuranceModel as default };
//# sourceMappingURL=assurance.js.map
